import React, { Suspense, lazy } from 'react'
import { ColophonProvider } from '@!/providers'
const Colophon = lazy(() => import('../containers/Colophon'))

const ColophonApp = (props) => {
  if (!props.content) return null

  return (
    <ColophonProvider>
      <Suspense fallback={null}>
        <Colophon content={props.content} />
      </Suspense>
    </ColophonProvider>
  )
}

export default ColophonApp
